import "./YouTubePlaylistEmbed.css";

function extractPlaylistId(value) {
  if (!value) return null;
  const match = value.match(/[?&]list=([^&\s"]+)/);
  return match ? match[1] : value.trim();
}

export default function YouTubePlaylistEmbed({ playlistId, title = "Playlist" }) {
  const id = extractPlaylistId(playlistId);
  if (!id) return null;
  return (
    <div className="playlist-embed">
      <iframe
        src={`https://www.youtube.com/embed/videoseries?list=${id}`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
}
